import useSWR from "swr";
import { useParams } from "react-router-dom";
import { fetcher } from "../../../util/api";
import { ChevronLeft } from "lucide-react";
import { Button } from "../../../components/ui/button";
import { cn } from "../../../lib/utils";
import ManageFleetOwners from "../../../componentsV2/ManageFleetOwners";
import FleetOwnerPayoutRecords from "../../../components/request/FleetOwnerPayoutRecords";


const FleetOwnerPayouts: React.FC = () => {
  const params = useParams();

  const { data: details, isLoading } = useSWR<FleetOwner>(
    `/newAdmin/fleet-owner/${params?.fleetOwnerId}`,
    fetcher
  );

  return (
    <div className={cn("h-full grid grid-cols-1 gap-4 transition-all duration-300", details && "md:grid-cols-[1fr_350px]",)}>
      <div className="bg-white">
        <div className="flex items-center justify-between">
          <div className="my-8">
            <h1 className="text-lg mb-0 flex items-center gap-2 font-bold">
              <Button variant="ghost" className="text-blue-600" onClick={() => window.history.back()}>
                <ChevronLeft className="text-lg" />
                <span className="font-bold">
                  Back
                </span>
              </Button>
            </h1>
          </div>
        </div>
        <div className="site-layout-background w-full overflow-auto p-4">
          <FleetOwnerPayoutRecords fleetOwnerId={params?.fleetOwnerId} />
        </div>
      </div>
      {!isLoading && details && <ManageFleetOwners selectedUser={details} handleClosePanel={() => {}} />}
    </div>
  );
};

export default FleetOwnerPayouts;
